import { NextAppHead } from '@zurich-framework/nextapp/components';
import { useBasePath, useTranslation } from '@zurich/common/hooks';

export function Head() {
  const { withBasePath } = useBasePath();
  const { t } = useTranslation();

  return (
    <NextAppHead title={t('titleFallback')}>
      <meta name="theme-color" content="#003399" />
      <link
        rel="shortcut icon"
        href={withBasePath('favicons/favicon.ico')}
        type="image/x-icon"
      />
      {/*<!-- iPad and iPad mini (with @2× display) iOS ≥ 8 -->*/}
      <link
        rel="apple-touch-icon-precomposed"
        sizes="180x180"
        href={withBasePath('favicons/apple-touch-icon-180x180-precomposed.png')}
      />
      {/*<!-- iPad 3+ (with @2× display) iOS ≥ 7 -->*/}
      <link
        rel="apple-touch-icon-precomposed"
        sizes="152x152"
        href={withBasePath('favicons/apple-touch-icon-152x152-precomposed.png')}
      />
      {/*<!-- iPad (with @2× display) iOS ≤ 6 -->*/}
      <link
        rel="apple-touch-icon-precomposed"
        sizes="144x144"
        href={withBasePath('favicons/apple-touch-icon-144x144-precomposed.png')}
      />
      {/*<!-- iPhone (with @2× and @3 display) iOS ≥ 7 -->*/}
      <link
        rel="apple-touch-icon-precomposed"
        sizes="120x120"
        href={withBasePath('favicons/apple-touch-icon-120x120-precomposed.png')}
      />
      {/*<!-- iPhone (with @2× display) iOS ≤ 6 -->*/}
      <link
        rel="apple-touch-icon-precomposed"
        sizes="114x114"
        href={withBasePath('favicons/apple-touch-icon-114x114-precomposed.png')}
      />
      {/*<!-- iPad mini and the first- and second-generation iPad (@1× display) on iOS ≥ 7 -->*/}
      <link
        rel="apple-touch-icon-precomposed"
        sizes="76x76"
        href={withBasePath('favicons/apple-touch-icon-76x76-precomposed.png')}
      />
      {/* <!-- iPad mini and the first- and second-generation iPad (@1× display) on iOS ≤ 6 -->*/}
      <link
        rel="apple-touch-icon-precomposed"
        sizes="72x72"
        href={withBasePath('favicons/apple-touch-icon-72x72-precomposed.png')}
      />
      {/*<!-- Android Stock Browser and non-Retina iPhone and iPod Touch -->*/}
      <link
        rel="apple-touch-icon-precomposed"
        href={withBasePath('favicons/apple-touch-icon-57x57-precomposed.png')}
      />
      {/*<!-- Fallback for everything else -->*/}
      <link
        rel="shortcut icon"
        href={withBasePath('favicons/apple-touch-icon.png')}
      />
      {/*<!-- Chrome 31+ has home screen icon 192×192 (the recommended size for multiple resolutions). If it’s not defined on that size it will take 128×128. -->*/}
      <link
        rel="icon"
        sizes="192x192"
        href={withBasePath('favicons/touch-icon-192x192.png')}
      />
      <link
        rel="icon"
        sizes="128x128"
        href={withBasePath('favicons/touch-icon-128x128.png')}
      />
      {/*<!-- Windows 8 Tile Icons -->*/}
      <meta name="application-name" content="Zurich Platform" />
      <meta name="msapplication-TileColor" content="#dddddd" />
      <meta
        name="msapplication-TileImage"
        content={withBasePath('favicons/tile.png')}
      />
      {/*<!-- IE11 Tile Icons -->*/}
      <meta
        name="msapplication-square70x70logo"
        content={withBasePath('favicons/smalltile.png')}
      />
      <meta
        name="msapplication-square150x150logo"
        content={withBasePath('favicons/mediumtile.png')}
      />
      <meta
        name="msapplication-wide310x150logo"
        content={withBasePath('favicons/widetile.png')}
      />
      <meta
        name="msapplication-square310x310logo"
        content={withBasePath('favicons/largetile.png')}
      />
      <link rel="manifest" href={withBasePath('manifest.json')} />
    </NextAppHead>
  );
}
